import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Chip,
  CircularProgress,
  Typography
} from '@mui/material';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import moment from 'moment';

const BookingsTable = ({ bookings, loading, onMenuOpen }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'confirmed':
        return 'success';
      case 'hold':
        return 'warning';
      case 'cancelled':
        return 'error';
      default:
        return 'default';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'confirmed':
        return 'Confirmado';
      case 'hold':
        return 'Reservado';
      case 'cancelled':
        return 'Cancelado';
      default:
        return status;
    }
  };

  const getPaymentStatusLabel = (status) => {
    const labels = {
      pending: 'Pendente',
      completed: 'Pago',
      failed: 'Falhou',
      refunded: 'Reembolsado'
    };
    return labels[status] || status;
  };

  const getPaymentStatusColor = (status) => {
    const colors = {
      pending: 'warning',
      completed: 'success',
      failed: 'error',
      refunded: 'default'
    };
    return colors[status] || 'default';
  };

  if (loading) {
    return (
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <CircularProgress />
      </Paper>
    );
  }

  if (bookings.length === 0) {
    return (
      <Paper
        sx={{
          p: 8,
          textAlign: 'center',
          bgcolor: 'grey.50',
          borderRadius: 2,
          border: '1px dashed',
          borderColor: 'grey.300'
        }}
      >
        <Typography variant="h6" color="text.secondary" gutterBottom>
          Nenhum agendamento encontrado
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Não há agendamentos para o filtro selecionado
        </Typography>
      </Paper>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow sx={{ bgcolor: 'grey.50' }}>
            <TableCell sx={{ fontWeight: 600 }}>Horário</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Serviço</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Cliente</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Barbeiro</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Pagamento</TableCell>
            <TableCell sx={{ fontWeight: 600 }} align="right">Valor</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Agendado em</TableCell>
            <TableCell sx={{ fontWeight: 600 }} align="center">Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {bookings.map((booking) => (
            <TableRow
              key={booking.id || booking._id}
              sx={{
                '&:hover': {
                  bgcolor: 'action.hover'
                },
                '&:last-child td, &:last-child th': { border: 0 }
              }}
            >
              <TableCell>
                {moment(booking.startAt).format('HH:mm')}
              </TableCell>
              <TableCell>
                {booking.service?.name || 'N/A'}
              </TableCell>
              <TableCell>
                {booking.customer?.name || 'N/A'}
              </TableCell>
              <TableCell>
                {booking.employee?.name || 'N/A'}
              </TableCell>
              <TableCell>
                <Chip
                  label={getStatusLabel(booking.status)}
                  color={getStatusColor(booking.status)}
                  size="small"
                />
              </TableCell>
              <TableCell>
                <Chip
                  label={getPaymentStatusLabel(booking.payment?.status || 'pending')}
                  color={getPaymentStatusColor(booking.payment?.status || 'pending')}
                  size="small"
                />
              </TableCell>
              <TableCell align="right">
                {new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL'
                }).format(booking.payment?.amount || 0)}
              </TableCell>
              <TableCell>
                {moment(booking.createdAt).fromNow()}
              </TableCell>
              <TableCell align="center">
                {booking.status !== 'cancelled' && (
                  <IconButton
                    size="small"
                    onClick={(e) => onMenuOpen(e, booking)}
                    title="Ações"
                  >
                    <MoreVertIcon />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BookingsTable;
